/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { invitationStatuses } from '../../../../shared/enums/invitationStatus';
import { acceptInvitation, declineInvitation } from './user.handleInvitation.thunk';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  invitation: undefined,
  invitationStatus: 'pending',
  dialog: { open: false },
  error: undefined,
};

/* Slice */
export const handleInvitationSlice = createSlice({
  name: 'handleInvitation',
  initialState,
  reducers: {
    toggleDialog(state, action) {
      state.dialog.open = action.payload;
    },
    updateInvitation(state, action) {
      state.invitation = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(acceptInvitation.pending, (state) => {
        state.status = ThunkStatus.LOADING;
        state.invitationStatus = undefined;
      })
      .addCase(acceptInvitation.fulfilled, (state) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.invitationStatus = invitationStatuses.ACCEPTED;
        state.error = undefined;
      })
      .addCase(acceptInvitation.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.invitationStatus = invitationStatuses.FAILED;
        state.error = action?.error?.message;
      })
      .addCase(declineInvitation.pending, (state) => {
        state.status = ThunkStatus.LOADING;
        state.invitationStatus = undefined;
      })
      .addCase(declineInvitation.fulfilled, (state) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.invitationStatus = invitationStatuses.DECLINED;
        state.dialog.open = false;
        state.error = undefined;
      })
      .addCase(declineInvitation.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.invitationStatus = invitationStatuses.FAILED;
        state.error = action?.error?.message;
      });
  },
});

/* Selectors */
const selectHandleInvitationSlice = state => state[handleInvitationSlice.name];

export const selectDialog = createSelector(selectHandleInvitationSlice, s => s.dialog);
export const selectStatus = createSelector(selectHandleInvitationSlice, s => s.status);
export const selectInvitation = createSelector(selectHandleInvitationSlice, s => s.invitation);
export const selectInvitationStatus = createSelector(selectHandleInvitationSlice, s => s.invitationStatus);

/* Actions */
export const { toggleDialog, updateInvitation } = handleInvitationSlice.actions;
